import {RouteConfig} from 'vue-router';
import {Routes} from '@/router/Routes';
import AccreditationApi from '@/modules/accredition/services/AccreditationApi';
import AccreditationStore from '@/modules/accredition/services/store/accreditation/AccreditationStore';
import {AccreditationStep} from '@/commons/enums/AccreditationStep';
import {AccreditationInvitation} from '@/modules/accredition/models/backend/AccreditationInvitation';
const stepRepresentantData = () => import(/* webpackChunkName: "stepRepresentantData" */ '@/modules/accredition/views/steps/StepRepresentantData.vue');
const stepExpertsData = () => import(/* webpackChunkName: "stepExpertsData" */ '@/modules/accredition/views/steps/StepExpertsData.vue');
const stepHrData = () => import(/* webpackChunkName: "stepHrData" */ '@/modules/accredition/views/steps/StepHrData.vue');
const stepBankAccesses = () => import(/* webpackChunkName: "stepBankAccesses" */ '@/modules/accredition/views/steps/StepBankAccesses.vue');
const stepCompanyData = () => import(/* webpackChunkName: "stepCompanyData" */ '@/modules/accredition/views/steps/StepCompanyData.vue');
const stepProfileData = () => import(/* webpackChunkName: "stepProfileData" */ '@/modules/accredition/views/steps/StepProfileData.vue');
const baseAccreditationNavigation = () => import(/* webpackChunkName: "baseAccreditationNavigation" */ '@/modules/accredition/views/AccreditationNavigation.vue');
const startBhpTest = () => import(/* webpackChunkName: "startBhpTest" */ '@/modules/bhp/views/StartBhpTest.vue');
const startKnfTest = () => import(/* webpackChunkName: "startKnfTest" */ '@/modules/knf/views/StartKnfTest.vue');
const stmtQuiz = () => import(/* webpackChunkName: "stmtQuiz" */ '@/modules/Statements/views/StatementsQuiz.vue');
const ethicQuiz = () => import(/* webpackChunkName: "ethicQuiz" */ '@/modules/Ethics/views/EthicQuiz.vue')
const startCyberSecurityTest = () => import(/* webpackChunkName: "startCyberSecurityTest" */ '@/modules/cyberSecurity/views/StartCyberSecurityTest.vue');
const startAmlTest = () => import(/* webpackChunkName: "startAmlTest" */ '@/modules/aml/views/StartAmlTest.vue');
const startRodoTest = () => import(/* webpackChunkName: "startRodoTest" */ '@/modules/rodo/views/StartRodoTest.vue');

const AccreditationRoutes: RouteConfig =
  {
    path: 'accreditation',
    name: Routes.ACCREDITATION_BASE,
    beforeEnter: async(to, from, next) => {
      try {
        const response = await AccreditationApi.getCompany();
        AccreditationStore.setCreatedCompany(response);
      } catch (e) {
        console.warn('No company data found');
      }
      try {
        const response: AccreditationInvitation = await AccreditationApi.getAccreditationInvitation();
        AccreditationStore.setAccreditationInvitation(response);
        if (response.companyId) {
          AccreditationStore.setCompanyId(response.companyId);
        } else {
          // Chief invitations does not have companyId
          console.warn('company id does not exist');
        }
      } catch (e) {
        console.warn('No invitation data found');
      }
      const companyId = AccreditationStore.getCreatedCompanyId();
      if (companyId) {
        try {
          const step = await AccreditationApi.getStep(companyId);
          if (to.name && to.name !== step) {
            next({name: step,});
          } else {
            next();
          }
        } catch (e) {
          console.error('Error occured while getting step by companyId: ' + companyId);
          next();
        }
      } else {
        next();
      }
    },
    component: baseAccreditationNavigation,
    children: [
      {
        name: Routes.ACCREDITATION.COMPANY_DATA,
        path: Routes.ACCREDITATION.COMPANY_DATA,
        component: stepCompanyData,
      },
      {
        name: Routes.ACCREDITATION.PERSONAL_DATA,
        path: Routes.ACCREDITATION.PERSONAL_DATA,
        component: stepRepresentantData,
      },
      {
        name: Routes.ACCREDITATION.EXPERTS,
        path: Routes.ACCREDITATION.EXPERTS,
        component: stepExpertsData,
      },
      {
        name: Routes.ACCREDITATION.HR_DATA,
        path: Routes.ACCREDITATION.HR_DATA,
        component: stepHrData,
      },
      {
        name: Routes.ACCREDITATION.BANKING_ACCESSES,
        path: Routes.ACCREDITATION.BANKING_ACCESSES,
        component: stepBankAccesses,
      },
      {
        name: Routes.ACCREDITATION.BHP_TEST,
        path: Routes.ACCREDITATION.BHP_TEST,
        component: startBhpTest,
      },
      {
        name: Routes.ACCREDITATION.CYBER_TEST,
        path: Routes.ACCREDITATION.CYBER_TEST,
        component: startCyberSecurityTest,
      },
      {
        name: Routes.ACCREDITATION.AML_TEST,
        path: Routes.ACCREDITATION.AML_TEST,
        component: startAmlTest,
      },
      {
        name: Routes.ACCREDITATION.RODO_TEST,
        path: Routes.ACCREDITATION.RODO_TEST,
        component: startRodoTest,
      },
      {
        name: Routes.ACCREDITATION.KNF_TEST,
        path: Routes.ACCREDITATION.KNF_TEST,
        component: startKnfTest,
      },
        {
          name: Routes.ACCREDITATION.ETHIC_TEST,
          path: Routes.ACCREDITATION.ETHIC_TEST,
          component: ethicQuiz,
        },
        {
          name: Routes.ACCREDITATION.STMT_TEST,
          path: Routes.ACCREDITATION.STMT_TEST,
          component: stmtQuiz,
        },
      {
        name: Routes.ACCREDITATION.EXPERT_PROFILE,
        path: Routes.ACCREDITATION.EXPERT_PROFILE,
        component: stepProfileData,
      },
    ],
  };

export default AccreditationRoutes;
